function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.08 4.67a.533.533 0 000 .76l1.028 1.028H2.125A.543.543 0 001.583 7c0 .298.244.542.542.542h4.983L6.08 8.57a.533.533 0 000 .758.533.533 0 00.759 0l1.944-1.944a.54.54 0 000-.764L6.838 4.67a.533.533 0 00-.759 0zm5.253 6.122H7.542a.543.543 0 00-.542.541c0 .298.244.542.542.542h3.791c.596 0 1.084-.488 1.084-1.083V3.208c0-.596-.488-1.083-1.084-1.083H7.542A.543.543 0 007 2.667c0 .298.244.541.542.541h3.791v7.584z",
  fill: "currentColor"
});

var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgLogin;